import { lazy } from 'react';

export const TeamCarousel = lazy(() => import('./TeamCarousel'));
